import logo from "../../assets/logo.png";

/**
 * The RemNutri brand mark.
 *
 * Was a hand-drawn SVG butterfly in a generic purple that had nothing to do with
 * the brand; this renders the real asset instead.
 *
 * The artwork is a tile — a solid cream ground with no transparency — so it is
 * given rounded corners to read as a deliberate app icon against the dark
 * sidebar rather than a pasted rectangle.
 *
 * `alt` is empty on purpose. In the expanded sidebar the word "RemNutri" sits
 * beside it, and when collapsed it lives inside a button that already carries
 * its own aria-label, so announcing the image again would just repeat.
 */
const Logo = ({ width = 28, height = 28, className = "" }) => (
  <img
    src={logo}
    alt=""
    width={width}
    height={height}
    // Both the attribute and the style: the attributes keep the space reserved
    // before the image decodes, the style stops a parent flex rule stretching it.
    style={{ width, height }}
    className={`shrink-0 rounded-md object-contain ${className}`}
  />
);

export default Logo;
